import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllCountrie } from "../../services/authServices";

export const getCountries = createAsyncThunk("countries", async () => {
  try {
    const request = await getAllCountrie();
    const response = await request.data; 
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const getCountriesSlice = createSlice({
  name: "countries",
  initialState: {
    result:null,
    message: null,
    status: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.result = action.payload?.data;
      state.message = "success";
      state.status = 200;
    });
    builder.addCase(getCountries.pending, (state, action) => {});
    builder.addCase(getCountries.rejected, (state, action) => {
      state.message = action.error.message;
    });
  },
});

export default getCountriesSlice.reducer;
